import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

// Utils
import { DomainRouting } from 'src/app/core/utils';

// Services
import { LoginService } from 'src/app/core/services/login';

@Injectable()
export class AuthGuard {
    public constructor(private router: Router,
        private domainRoutingService: DomainRouting,
        private loginService: LoginService) { }

    public canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

        //Define la lista de rutas que son siempre públicas
        const publicRoutes = ['survey-anonymous/:id'];
        const currentPath = activatedRouteSnapshot.routeConfig?.path || '';

        //Comprueba si la ruta actual es una de las públicas
        if (publicRoutes.includes(currentPath)) {
            return true; // Si es pública, permite el acceso inmediatamente
        }

        let canActivate = false;

        if (!this.loginService.validateUserLocalStorage()) {
            if (this.isInBrowser()) {
                this.domainRoutingService.redirectToAuthPoint(this.router, routerStateSnapshot.url);
            }
        } else if (this.loginService.isTokenExpired()) {
            this.loginService.logout(false);
            this.domainRoutingService.redirectToAuthPoint(this.router, routerStateSnapshot.url);
        } else {
            canActivate = true;
        }

        return canActivate;
    }

    private isInBrowser(): boolean {
        return typeof window !== 'undefined';
    }
}
